export default "__VITE_ASSET__Cz036Mr6__"